export const getTiposGestao = (state) => state.tiposGestao.lista
export const getIsSavingTiposGestao = (state) => state.tiposGestao.isSaving
export const getIsCarregandoListaTiposGestao = (state) => state.tiposGestao.isCarregandoLista
export const getIsUpdatingTiposGestao = (state) => state.tiposGestao.isUpdating
